import {HomepageCreatePopupPanel} from '@Panels/homepage-create-popup-panel/homepage-create-popup-panel';

export default HomepageCreatePopupPanel;
